import React, { useState } from "react";
import "./Project_Details.css";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Projects_Fullscreen_Modal from "../common_components/common_modal/projects_fullscreen_modal/Projects_Fullscreen_Modal";
import { useParams } from "react-router-dom";
import { projects } from "../../store";

const Project_Details = () => {
  const { id } = useParams();

  const projectData = projects?.find((item) => item?.id === Number(id));

  const breadcrumbs = [
    { label: "Projects", link: "/", isActive: false },
    { label: projectData?.projectName, link: "", isActive: true },
  ];

  const data = [
    {
      title: "Open Living Spaces:",
      descn:
        "Creating open-plan living areas to enhance the flow and connection between indoor and outdoor spaces.",
    },
    {
      title: "Outdoor Living:",
      descn:
        "Designing extensive outdoor areas, including a deck, pool, and garden, for relaxation and entertaining.",
    },
    {
      title: "Large Windows:",
      descn:
        "Installing floor-to-ceiling windows to maximize natural light and provide unobstructed ocean views.",
    },
    {
      title: "Modern Amenities:",
      descn:
        "Incorporating state-of-the-art kitchen appliances, smart home technology, and luxurious bathroom fixtures.",
    },
  ];

  const galleryData = [
    "/assets/images/home/our_services/client_verticle_images/img2.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img5.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img7.jpeg",
    "/assets/images/home/our_services/client_verticle_images/img8.jpeg",
  ];

  const [showModal, setShowModal] = useState(false);

  return (
    <section className="Project_Details">
      <div className="container">
        <div className="top_div">
          <Breadcrumb_comp breadcrumbs={breadcrumbs} />
        </div>

        <div className="details_div">
          <p className="heading_text">
            {projectData?.projectName},{" "}
            <span className="location">{projectData?.location}</span>{" "}
          </p>
          <p className="desn_text">{projectData?.descn?.[0]}</p>

          <div className="img_holder">
            <img
              src={process.env.PUBLIC_URL + projectData?.mainImg}
              className="project_img"
            />
          </div>

          <p className="heading_text">Design in Details</p>
          <p className="desn_text">{projectData?.descn?.[1]}</p>

          <div className="features_div">
            <div className="row">
              {projectData?.highlights?.map((item) => {
                return (
                  <div className="col-sm-6">
                    <div className="details_card">
                      <img
                        src="/assets/images/services/key_elements/checked.png"
                        className="point_img"
                      />

                      <div className="content_div">
                        <p className="label_text">{item?.label}</p>
                        <p className="descn">{item?.value}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <p className="heading_text">Gallery</p>

          <div className="content_div">
            <div className="row">
              {projectData?.imgs?.slice(0, 4)?.map((item) => {
                return (
                  <div className="col-lg-3 col-md-4 col-6 mb-4">
                    <div
                      className="gallary_img_div"
                      onClick={() => {
                        setShowModal(true);
                      }}
                    >
                      <img
                        src={process.env.PUBLIC_URL + item}
                        className="inner_img"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <Projects_Fullscreen_Modal
        projectData={projectData}
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Project_Details;
